export var ItemTypeServer;
(function (ItemTypeServer) {
    ItemTypeServer[ItemTypeServer["menuItem"] = 1] = "menuItem";
    ItemTypeServer[ItemTypeServer["sequencedFlow"] = 2] = "sequencedFlow";
    ItemTypeServer[ItemTypeServer["nonSequencedFlow"] = 3] = "nonSequencedFlow";
    ItemTypeServer[ItemTypeServer["quiz"] = 5] = "quiz";
    ItemTypeServer[ItemTypeServer["resources"] = 6] = "resources";
})(ItemTypeServer || (ItemTypeServer = {}));
